import { graphql } from 'gatsby'
import React from 'react'
import loadable from '@loadable/component'
import Header from '../components/careers/Header'
import Layout from '../components/Layout'

const PostingList = loadable(() => import('../components/careers/PostingList'))


const Career = ({data: {page, allPostings, positionLocations}}) => {
    return (
        <Layout meta={page.frontmatter.meta || false}>
            <Header data={page.frontmatter}/>
            <PostingList allPostings={allPostings} positionLocations={positionLocations}/>
        </Layout>
    )
}

export default Career

export const pageQuery = graphql `
    query Career($id: String!){
        page: markdownRemark(id: {eq: $id}){
            ...Meta
            frontmatter {
                featuredImage
                bannerTitle
                bannerDescription
            }
        }
        allPostings: allMarkdownRemark(sort: {order: ASC, fields: frontmatter___date}, filter: {fields: {contentType: {eq: "careers"}}}) {
            edges {
              node {
                frontmatter {
                  bannerTitle
                  positionSubdescription
                  responsiblities {
                    responsiblity
                  }
                  requirements {
                    requirement
                  }
                  desirables {
                    desirable
                  }
                  positionListingImage
                  description
                  location
                  date(formatString: "DD.MM.YYYY")
                }
                fields {
                  contentType
                  slug
                }
              }
            }
        }
        positionLocations: allMarkdownRemark(filter: {fields: {contentType: {eq: "jobLocations"}}}) {
            edges {
                node {
                    frontmatter {
                        title
                    }
                    fields {
                        contentType
                        slug
                    }
                }
            }
        }
    }
`